module.exports = __webpack_public_path__ + "static/img/home-banners.46254310.jpg";